'use client';

import {helpFormTranslates} from '@shared/Modals/SupportModal/SupportModal/helpFormTranslates';
import {retryPromise} from '@utils/retryPromise';
import dynamic from 'next/dynamic';
import {useCallback, useState} from 'react';

import {useLocale} from '@utils/hooks/useLocale';

import styles from './SupportButton.module.scss';

type Props = {
  logTmrEvent: (eventName: string, params: Record<string, unknown>) => void;
};
const SupportModal = dynamic(
  retryPromise(async () =>
    import(
      /* webpackChunkName: "SupportModal" */ '@shared/Modals/SupportModal/SupportModal/SupportModal'
    ).then((data) => data.SupportModal),
  ),
  {ssr: false},
);

export const SupportButton = ({logTmrEvent}: Props) => {
  const [modalShown, setModalShown] = useState(false);
  const locale = useLocale();
  const setShowModal = useCallback(
    () => setModalShown(!modalShown),
    [modalShown],
  );
  const onClick = () => {
    logTmrEvent('button.click', {button_text: 'Написать в поддержку'});
    setShowModal();
  };

  return (
    <>
      {modalShown && <SupportModal setShowModal={setShowModal} />}
      <button
        className={styles.button}
        onClick={onClick}
        data-testid={'support_button_id'}
      >
        {helpFormTranslates.title[locale]}
      </button>
    </>
  );
};
